export default "__VITE_ASSET__DjJJ1Tmw__"